import styled from "styled-components";
import { Container } from "../styled/CommonStyledComponents";
import CardComponent from "../atomic/CardComponent";
import DetailComponent from "../atomic/DetailComponent";

const features = [
  {
    title: "One-Click Customs",
    description:
      "Scan shipment orders and instantly file compliant customs paperwork on CEISA 4.0—no manual entry required.",
    icon: "./assets/icon/images/credit.svg",
    background: "linear-gradient(to bottom, #C2EFFF 0%, #ffffff 100%)"
  },
  {
    title: "Smart Quote Builder",
    description:
      "Build a ready-to-send pricing menu your customers can choose from. Update rates, generate quotes, and respond to RFQs instantly.",
    icon: "./assets/icon/images/payment.svg",
    background:
      "radial-gradient(circle at 80% 20%, rgba(255, 192, 203, 0.3), transparent 70%), linear-gradient(to bottom, #de82aa 0%, #ffffff 100%)"
  }
];

const subFeatures = [
  {
    title: "Auto Entry",
    description:
      "Effortlessly handles your most tedious tasks processing documents, updating freight systems, and filling in third-party portals.",
    icon: "./assets/icon/images/ai-icon.svg"
  },
  {
    title: "Instant Document Generator",
    description:
      "Automatically create shipping documents from order details using AI. Save hours on paperwork and avoid costly typos or errors that could delay shipments.",
    icon: "./assets/icon/images/customer.svg"
  },
  {
    title: "Customer & Agent Insights",
    description:
      "Identify your most valuable clients and agents. Receive notifications to reactivate inactive customers and strengthen loyalty with top performers.",
    icon: "./assets/icon/images/document.svg"
  }
];

export default function PowerUpSection() {
  return (
    <div style={{ width: "100%", alignItems: "center" }}>
      <FeatureContainer>
        <Row>
          {features.map((feature, index) => (
            <CardComponent feature={feature} index={index} />
          ))}
        </Row>

        <SubFeatureRow>
          {subFeatures.map((feature, i) => (
            <DetailComponent
              feature={feature}
              index={i}
              isLast={i === subFeatures.length - 1}
            />
          ))}
        </SubFeatureRow>

        {/* <ButtonContainer>
          <GlowingButton>Discover our array of Power Up</GlowingButton>
        </ButtonContainer> */}
      </FeatureContainer>
    </div>
  );
}

const FeatureContainer = styled(Container)`
  // padding-top: 40px;

  @media (max-width: 767px) {
    // flex-direction: column;
    width: 100%;
  }
`;

const SubFeatureRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 84px;

  @media (max-width: 1025px) {
    margin-top: 48px;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    margin-top: 24px;
    gap: 0;
  }
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 64px;
  padding: 24px 32px;
  flex-direction: row;

  @media (max-width: 1025px) {
    flex-wrap: nowrap;
    gap: 32px;
    padding: 24px 32px;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    max-width: 100%;
    gap: 24px;
    padding: 24px 32px;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  align-items: center;
  margin-top: 48px;
  display: flex;
  justify-content: center;
  margin-bottom: 108px;

  @media (max-width: 767px) {
    margin-top: 12px;
    margin-bottom: 32px;
  }
`;

const GlowingButton = styled.button`
  background: linear-gradient(180deg, #0b1c75 0%, #0d2c99 100%);
  color: white;
  border: 2px solid #3edcff;
  border-radius: 30px;
  padding: 0.75rem 3rem 0.75rem 3rem;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  position: relative;
  z-index: 1;
  box-shadow: 0 0 10px #3edcff, 0 0 30px #9d8cff;
`;
